<template>
  <div class="horizon-container">
    <div class="sideBar">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">基础信息定义</div>
      </div>
      <div class="flex-1 h-0">
        <div class="menuItem" v-for="(item, index) in sidebarList" :key="index" :class="{'activeItem': index === sidebarIndex}" @click="onChooseSidebar(index)">
          <div class="index">{{index + 1}}</div>
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="flex-1 h-100 flex">
      <div class="menu h-100 flex-column" id="moveLeft" style="width: 200px">
        <div class="left-top">
          <div class="flex-1 font-16-30313a flex justify-space-between align-center">
            <div>{{sidebarIndex === 0 ? '选项分类' : '零售客户分类'}}</div>
            <div class="tip-20-bg-30313a cursor" v-if="sidebarIndex === 1"  @click="addClassify">
              <i class="el-icon-plus font-bold"></i>
            </div>
          </div>
        </div>
        <div class="flex-1 h-0">
          <div class="menuItem flex justify-space-between" v-for="(item, index) in sidebarList[sidebarIndex].menu" :key="index" :class="{'activeMenu': index === menuIndex}" @click="onChooseMenu(index)">
            <div>{{item.name}}</div>
            <div class="btn-container" v-if="sidebarIndex === 1">
              <i class="el-icon-edit mr-5" @click="onEditClassify(item)"></i>
              <i class="el-icon-circle-close" @click="onDeleteClassify(item)"></i>
            </div>
          </div>
        </div>
      </div>
      <move-horizon></move-horizon>
      <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
        <div class="title flex align-center bg-ff mb-10" v-if="sidebarList[sidebarIndex].menu.length > 0">
          <div class="decoration-line mr-5"></div>
          <div class="font-16-f5971d font-bold">{{sidebarList[sidebarIndex].menu[menuIndex].name}}明细</div>
        </div>
        <div class="mb-10 flex align-center">
          <div class="flex align-center mr-5 mb-5" @click="onOperate(item)" :class="index === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in btnList" :key="index">
            <img :src="index === Index ? item.iconActive : item.icon" class="icon-14 mr-5" alt="">
            <div>{{item.name}}</div>
          </div>
        </div>
        <div class="flex-1 h-0">
          <erp-table :is-edit="true" ref="erpTable" :table-data="tableData" :loading="loading" :column-data="columnData"  @on-modify="onModifyRow" modify-method="on-modify" @on-modify-up="onMoveUp" @on-modify-down="onMoveDown"
                     :customs="[{field: 'remove', visible: sidebarIndex === 0}, {field: 'text', visible: sidebarIndex === 0}, {field: 'name', visible: sidebarIndex === 1}, {field: 'address', visible: sidebarIndex === 1}, {field: 'contact', visible: sidebarIndex === 1}, {field: 'contactTelephone', visible: sidebarIndex === 1}]"></erp-table>
        </div>
        <Pagination v-if="sidebarIndex === 1" class="mt-10" :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import MoveHorizon from '../../components/MoveHorizon'
import ErpTable from '../../components/ErpTable'
import Pagination from '@/components/Pagination'
export default {
  name: 'basicDefine',
  components: {MoveHorizon, ErpTable, Pagination},
  data () {
    return {
      sidebarList: [{
        name: '业务分类定义',
        menu: [{
          name: '客户类型',
          group: 'customerType'
        }, {
          name: '客户来源',
          group: 'customerSource'
        }, {
          name: '房屋类型',
          group: 'houseType'
        }, {
          name: '户型',
          group: 'homeType'
        }, {
          name: '所在方位',
          group: 'location'
        }, {
          name: '客户关注',
          group: 'customerFocus'
        }, {
          name: '行业了解度',
          group: 'industryUnderstanding'
        }, {
          name: '装修风格',
          group: 'decorationStyle'
        }]
      }, {
        name: '零售客户定义',
        menu: []
      }],
      sidebarIndex: 0,
      menuIndex: 0,
      Index: -1,
      btnList: [{
        name: '添加',
        label: 'add',
        icon: '/static/images/add.png',
        iconActive: '/static/images/add-bai.png'
      }, {
        name: '删除',
        label: 'delete',
        icon: '/static/images/shanchu.png',
        iconActive: '/static/images/shanchu-bai.png'
      }],
      columnData: [{
        field: 'select',
        type: 'selection',
        width: '40',
        fixed: 'left'
      }, {
        field: 'remove',
        title: '移动',
        width: '120',
        fixed: 'left',
        isDefine: true,
        child: [{
          className: 'btn-16-bd-85 btn-hover mr-5',
          title: '上',
          methodName: 'on-modify-up',
          type: 'btn'
        }, {
          type: 'btn',
          className: 'btn-16-bg-85 btn-hover',
          title: '下',
          methodName: 'on-modify-down'
        }]
      }, {
        type: 'index',
        title: '序号',
        width: '60',
        fixed: 'left'
      }, {
        field: 'text',
        title: '日志名称',
        minWidth: '200',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'name',
        title: '客户名称',
        width: '200',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'address',
        title: '联系地址',
        width: '200',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'contact',
        title: '联系人',
        width: '200',
        editRender: {
          name: 'input'
        }
      }, {
        field: 'contactTelephone',
        title: '联系电话',
        minWidth: '200',
        editRender: {
          name: 'input'
        }
      }],
      page: 1,
      limit: 10,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100, // 总条数
      loading: true,
      tableData: [],
      currentOperate: ''
    }
  },
  created () {},
  mounted () {
    this.getBusiness()
  },
  methods: {
    onChooseSidebar (index) {
      if (index !== this.sidebarIndex) {
        this.sidebarIndex = index
        if (index === 0) {
          this.getBusiness()
        } else if (index === 1) {
          this.getCustomerList()
        }
      }
      this.menuIndex = 0
      this.page = 1
    },
    onChooseMenu (index) {
      if (index !== this.menuIndex) {
        this.menuIndex = index
        if (this.sidebarIndex === 0) {
          this.getBusiness()
        } else if (this.sidebarIndex === 1) {
          this.getCustomer()
        }
      }
      this.page = 1
    },
    onOperate (operate) {
      this.currentOperate = operate
      switch (operate.label) {
        case 'add':
          this.addData()
          break
        case 'delete':
          this.onDelete()
          break
      }
    },
    addClassify () {
      this.$prompt('请输入分类名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.axios.post(`retailCustomerClassify/save`, {
          companyId: this.$store.state.companyId,
          name: value
        }).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.getCustomerList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    getBusiness () {
      this.axios.post(`param/list`, {
        companyId: this.$store.state.companyId,
        group: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].group
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
          this.loading = false
        }
      })
    },
    onEditClassify (item) {
      this.$prompt('请输入分类名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.name
      }).then(({ value }) => {
        this.axios.post(`retailCustomerClassify/modify`, {
          id: item.id,
          name: value
        }).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '修改成功'
            })
            this.getCustomerList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        })
      })
    },
    onDeleteClassify (item) {
      this.$confirm(`此操作将删除${item.name}分类, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.post(`retailCustomerClassify/deleteById`, this.qs.stringify({
          id: item.id
        })).then(res => {
          if (res.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getCustomerList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    getCustomerList () {
      this.axios.post(`retailCustomerClassify/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.sidebarList[1].menu = res.data.data
          this.getCustomer()
        }
      })
    },
    getCustomer () {
      this.axios.post(`retailCustomer/queryForPage`, {
        classifyId: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].id,
        limit: this.limit,
        page: this.page
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.pageSize
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    addData (row) {
      if (this.sidebarIndex === 0) {
        let params = {
          companyId: this.$store.state.companyId,
          group: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].group,
          text: null,
          index: this.tableData.length
        }
        this.axios.post('param/save', params).then(res => {
          if (res.data.success) {
            this.$refs.erpTable.insertAt(res.data.data, -1, 'text')
            this.total++
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else if (this.sidebarIndex === 1) {
        let params = {
          companyId: this.$store.state.companyId,
          classifyId: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].id,
          name: null,
          address: null,
          contact: null,
          contactTelephone: null
        }
        this.axios.post('retailCustomer/save', params).then(res => {
          if (res.data.success) {
            this.$refs.erpTable.insertAt(res.data.data, -1, 'name')
            this.total++
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onDelete () {
      let selectArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < selectArr.length; i++) {
        idArr.push(selectArr[i].id)
        nameArr.push(selectArr[i].text)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('param/deleteByIds', that.qs.stringify({ids: idArr.join(',')})).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.erpTable.setAllSelection(false)
            that.getBusiness(true)
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onMoveUp (row) {
      if (row.index - 1 < 0) {
        this.$message({
          type: 'warning',
          message: '该数据已经在第一个了！'
        })
      } else {
        this.axios.post('param/modifyIndex', {
          step: -1,
          id: row.id,
          group: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].group,
          companyId: this.$store.state.companyId
        }).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.getBusiness(true)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onMoveDown (row) {
      if (row.index + 1 > this.tableData.length - 1) {
        this.$message({
          type: 'warning',
          message: '该数据已经在最后一个了！'
        })
      } else {
        this.axios.post('param/modifyIndex', {
          step: 1,
          id: row.id,
          group: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].group,
          companyId: this.$store.state.companyId
        }).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.getBusiness(true)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    onModifyRow (row, column, colName) {
      if (this.sidebarIndex === 0) {
        let params = {
          id: row.id,
          [colName]: row[colName],
          group: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].group,
          companyId: this.$store.state.companyId,
          index: row.index
        }
        this.axios.post('param/modify', params).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.getBusiness(false)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else if (this.sidebarIndex === 1) {
        let params = {
          id: row.id,
          [colName]: row[colName],
          classifyId: this.sidebarList[this.sidebarIndex].menu[this.menuIndex].id
        }
        this.axios.post('retailCustomer/modify', params).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.getCustomer(false)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    enter (a) {
      this.Index = a
      // this.classStyle = true
    },
    leave () {
      this.Index = -2
      // this.classStyle = false
    },
    jump (page) {
      this.page = page
      this.getCustomer()
    }
  }
}
</script>

<style lang="scss" scoped>
  .menu{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    background: #f9f9fb;
    width: 200px;
  }
  .hide-x{
    box-shadow: none!important;
  }
  .sideBar{
    width: 200px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
  }
  .menuItem{
    height: 36px;
    font-size: 14px;
    color: #30313a;
    padding:  0 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #e2e2e2;
    cursor: pointer;
    background: transparent;
  }
  .activeItem{
    color: #f5971d;
    background: #f9f9fb;
  }
  .index{
    width: 14px;
    height: 14px;
    background-color: #b9b9b9;
    border-radius: 4px;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    margin-right: 5px;
  }
  .activeItem .index{
    background: #f5971d;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .activeMenu{
    background: #f5971d;
    color: #fff;
  }
  .title{
    height: 30px;
    padding-left: 10px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/basicDefine.vue